
<template>

  <div>

    <div style="background: #f5f5f5; padding: 10px; border-radius: 4px">
      <div style="padding-bottom: 5px">
        <el-checkbox v-model="strictly">级联选择下级</el-checkbox>
      </div>
      <el-input
        v-model="filterText"
        placeholder="输入关键字进行过滤"
        size="small"
      />
    </div>


     <!-- default-expand-all -->
    <el-tree
      v-loading="treeLoading"
      ref="tree"
      :data="treeData"
      :check-strictly="!strictly"
      :default-checked-keys="deptCodes"
      :props="defaultProps"
      :filter-node-method="filterNode"
      style="margin-top: 10px"
      empty-text=" "
     
      show-checkbox
      node-key="id"
      @check-change="handleCheckChange"
      :default-expanded-keys="defaultOpenList"
    />

  </div>

</template>

<script>
import { fetchTree } from '@/api/examMan/sys/depart/depart'
export default {
  name: 'DepartRefs',
  props: {
    value: Array
  },
  data() {
    return {
      strictly: false,
      defaultProps: {
        label: 'label'
      },
      filterText: '',
      treeLoading: false,
      deptCodes: [],
      treeData: [],
      defaultOpenList:[],
    }
  },

  watch: {

    filterText(val) {
      this.$refs.tree.filter(val)
    },

    value(val) {
      this.deptCodes = val
    }
  },
  created() {
    // 初始化赋值
    this.deptCodes = this.value

    fetchTree().then(response => {
      console.log('====aaa', response)
      this.treeData = response.data.list

      this.defaultOpenList = [response.data.list[0].id]
      console.log('====this.defaultOpenList', this.defaultOpenList)
    })
  },
  methods: {

    handleCheckChange() {
      // 置空
      const deptCodes = []

      const nodes = this.$refs.tree.getCheckedNodes()
      nodes.forEach(function(item) {
        deptCodes.push(item.id)
      })

      this.$emit('input', deptCodes)
    },

    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    }

  }
}
</script>
